module.exports = __webpack_public_path__ + "img/arrow-down-circle-fill.c0d96e03.svg";